import apiClient from "@/services/ApiClient.js";

export default {
  getProducts() {
    return apiClient.get("/producttypes");
  },
  getProduct(id) {
    return apiClient.get("/producttypes/" + id);
  },
  createProduct(userProduct) {
      return apiClient.post("/userproducts", userProduct);
  },
  loadProduct(productGuid) {
    return apiClient.get("/userproducts", {
      params: {
        id: productGuid,
      },
    });
  },
};
